// 問い合わせ一覧用フィールド
import * as React from 'react';
import * as InquiryListField from '../constants/InquiryListField';
import * as PropTypes from 'prop-types';
import { Inquiry } from '../interfaces';

// 表のヘッダー部分.
export const inquiryHeader =  Object.keys(InquiryListField.inquiryHeader).map((key) => {
  return (
    <th key={key} scope="col">{InquiryListField.inquiryHeader[key]}</th>
  );
});

export let checkedUserIds: any[];

interface InquirySelectBodyProps extends React.Props<{}> {
  inquiries?: Inquiry[];
  moffAPI: any;
  moffAPIActions: any;
}

// 利用者一覧の表のフィールド表示用コンポーネント
export class InquirySelectBody extends React.Component<InquirySelectBodyProps, {}> {
  urlBase: string;
  btnText: string;

  /**
   *
   * @readonly
   * @static
   * @memberof InquirySelectBody
   */
  static get contextTypes() {
    return {
      callbackParent: PropTypes.func,
    };
  }

  /**
   * 一覧をクリックしたときの処理.
   *
   * @memberof InquirySelectBody
   */
  handleFieldClicked = (inquiryId: string) => {
    window.location.href = `${this.urlBase}${inquiryId}`;
  }

  componentWillMount() {
    this.urlBase = '/inquiries/details/';
  }

  /**
   * JSX描画.
   *
   * @returns
   * @memberof InquirySelectBody
   */
  render() {
    let inquiryFields = this.props.inquiries && this.props.inquiries.map((inquiry: Inquiry, i: number) => {
      return(
        <tr key={inquiry.inquiryId} onClick={event => this.handleFieldClicked(inquiry.inquiryId)}>
          <td>{inquiry.inquiryNumber}</td>
          <td>{inquiry.username}</td>
          <td>{inquiry.isNew ? 'New' : ''}</td>
          <td>{inquiry.updatedAt}</td>
          {/*
          <td>{inquiry.isClosed ? 'Close' : ''}</td>
          */}
        </tr>
      );
    });

    return (
      // {}は不要.
      inquiryFields
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InquiryListField.tsx